import React, { use } from 'react';

import type { ClubCmsRecord } from 'src/content/cms-provider/club-cms-provider';
import { SiteContext } from 'src/context/site-context';

import type { ClubMetadata } from '../../cms/helpers/clubs-metadata-helper';
import { getClubMetadata } from '../../cms/helpers/clubs-metadata-helper';

export const ClubCmsContent = React.createContext<ClubCmsRecord>(null as never);

export const ClubContentAndMetaConsumer = ({
  children,
}: {
  children: (cmsContent: ClubCmsRecord, clubMetadata: ClubMetadata) => React.ReactElement;
}) => {
  const { isGlobalPage, siteId } = use(SiteContext);
  const cmsContent = use(ClubCmsContent);

  if (isGlobalPage || !siteId) {
    throw new Error('Club specific content cannot be used on a global page!');
  }

  const clubMetadata = getClubMetadata(siteId);

  return children(cmsContent, clubMetadata);
};
